const INVALID_DATE_SENTINELS = new Set([
  '0000-00-00',
  '0000-00-00T00:00:00.000Z',
  '00-00-0000',
]);

export function parseDisplayDate(value) {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  if (!raw || INVALID_DATE_SENTINELS.has(raw)) return null;

  const date = new Date(raw);
  if (Number.isNaN(date.getTime()) || date.getFullYear() < 1971) return null;
  return date;
}

export function formatDisplayDate(value, fallback = '—') {
  const date = parseDisplayDate(value);
  if (!date) return fallback;
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatStatusHistoryDate(value, fallback = '—') {
  return formatDisplayDate(value, fallback);
}

export function formatRemarkDateTime(value, fallback = '—') {
  const date = parseDisplayDate(value);
  if (!date) return fallback;
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatInterviewDate(value, fallback = '—') {
  return formatDisplayDate(value, fallback);
}

export function toDateInputValue(value) {
  const date = parseDisplayDate(value);
  if (!date) return '';
  return date.toLocaleDateString('en-CA');
}

function isLegacyIsoLwdValue(raw) {
  return /^\d{4}-\d{2}-\d{2}/.test(raw) || (raw.includes('T') && !raw.includes('/'));
}

/** Display LWD as stored text; format legacy ISO/date strings for readability. */
export function formatLwdDisplay(value, fallback = '—') {
  if (value == null || value === '') return fallback;
  const raw = String(value).trim();
  if (!raw || INVALID_DATE_SENTINELS.has(raw)) return fallback;

  if (isLegacyIsoLwdValue(raw)) {
    const date = parseDisplayDate(value);
    if (date) {
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    }
  }

  return raw;
}

/** Pre-fill LWD text inputs from DB (plain text or legacy ISO). */
export function normalizeLwdForInput(value) {
  if (value == null || value === '') return '';
  const raw = String(value).trim();
  if (!raw || INVALID_DATE_SENTINELS.has(raw)) return '';

  if (isLegacyIsoLwdValue(raw)) {
    const date = parseDisplayDate(value);
    if (date) {
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    }
  }

  return raw;
}

export function toIsoDateString(value, fallback = null) {
  if (value == null || value === '') return fallback;

  const raw = String(value).trim();
  if (!raw || INVALID_DATE_SENTINELS.has(raw)) return fallback;

  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? `${raw}T00:00:00` : raw;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return fallback;

  return date.toISOString();
}
